export default __webpack_public_path__ + "static/Inter-ExtraBold-c6d39a2579ba19fa18e5f5e6608938c4.woff";